import React from "react";

const CardText = ({ primaryTitle, secondaryTitle, description, icon }) => {
  return (
    <div 
      className="flex-col" 
      style={{maxWidth: '475px', margin: '30px 80px'}}
      >
      <p style={{
        fontWeight: 600,
        fontSize: '25px',
        lineHeight: '37px',
        color: '#DB0090'
      }}>{primaryTitle}</p>
      <div
        style={{
          marginTop: '20px',
          borderRadius: "10px",
          background: "#FFFFFF",
          color: "#696969",
          boxShadow: "0px 8px 24px rgba(219, 0, 144, 0.15)",
          minHeight: '152px',
          padding: '30px'
        }}
        className="flex"
      >
        <img
          src={icon} 
          alt={secondaryTitle}
          style={{ width: '70px', height: '70px' }}
        />
        <div className="text-left" style={{ margin: 'auto 20px'}}>
          <div 
            style={{
                fontSize: '25px',
                lineHeight: '37px',
                color: '#26355C',
              }}
            >
              {secondaryTitle}
          </div>
          <p
            style={{
                fontSize: '18px',
                lineHeight: '27px',
                color: '#696969',
              }}
            >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CardText;
